import React, { FC } from 'react';
import StyledDialog from 'views/rebranded-module/GeoViewV2/components/ShowMapDialogSection/ShowMapDialogSection.styles';
import dynamic from 'next/dynamic';

const MapSection = dynamic(() => import('views/rebranded-module/GeoViewV2/components/MapSection').then((file) => file.MapSection));

const ShowMapDialogSection:FC<any> = (props) => {
  const {
    open,
    handleClose,
    mapLocations,
    selectedPlace,
    handleBikeCardClick,
    isWigetOpen,
    handleMapChange,
    renderSkeleton,
    // "Search this area" props — forwarded from MapAndFilter -> here -> MapSection.
    // These enable the same button/overlay/disabled-pins behavior inside the
    // mobile fullscreen map dialog as on the desktop sidebar map.
    unsearchedMapBounds,
    onSearchThisArea,
    isMapLoading,
    handleMapLoadingFlag,
    currentFilterParams,
  } = props;
  return (
    <StyledDialog fullScreen open={open} onClose={handleClose}>
      <MapSection
        mapLocations={mapLocations}
        selectedPlace={selectedPlace}
        handleClose={handleClose}
        handleBikeCardClick={handleBikeCardClick}
        isWigetOpen={isWigetOpen}
        handleMapChange={handleMapChange}
        renderSkeleton={renderSkeleton}
        currentFilterParams={currentFilterParams}
        unsearchedMapBounds={unsearchedMapBounds}
        onSearchThisArea={onSearchThisArea}
        isMapLoading={isMapLoading}
        handleMapLoadingFlag={handleMapLoadingFlag}
      />
    </StyledDialog>
  );
};

export { ShowMapDialogSection };
